import type { ConsoleUser } from "../context/AuthContext";

/** Paths that require `console_users` or superadmin — not plain admins without that permission. */
const CONSOLE_USERS_MANAGE_PATHS = new Set<string>(["/console-users"]);

function mayAccessConsoleUsersPage(u: ConsoleUser): boolean {
  return u.role === "superadmin" || u.permissions.includes("console_users");
}

/**
 * Where to send the user after a successful login (or when already signed in on `/login`).
 * Prevents e.g. bookmarked `/console-users` sending a user there without the manage-console-users permission.
 */
export function postLoginPath(from: string | undefined | null, signedInUser: ConsoleUser): string {
  const trimmed = typeof from === "string" ? from.trim() : "";
  const candidate = trimmed && trimmed !== "/login" ? trimmed : "/";
  if (!mayAccessConsoleUsersPage(signedInUser) && CONSOLE_USERS_MANAGE_PATHS.has(candidate)) {
    return "/";
  }
  return candidate;
}
